import React from 'react';
import PropTypes from 'prop-types';
import DispatchModalList from './DispatchModalList';

const DispatchCaptainsList = ({
  employees,
  handleUpdateModalState,
  selectedCaptainID,
  occupiedCaptains,
}) => {
  const columns = [
    { selector: 'name', title: 'Contremaîtres', type: 'string' },
    { selector: 'employee_number', title: 'No', type: 'number' },
  ];

  function handleItemClick(item) {
    let newCaptainID;
    if (selectedCaptainID === item.id) {
      newCaptainID = null;
    } else {
      newCaptainID = item.id;
    }

    handleUpdateModalState({ captain_id: newCaptainID });
  }

  const captains = employees.filter(employee => employee.is_captain);

  return (
    <DispatchModalList
      data={captains}
      selected={[selectedCaptainID]}
      columns={columns}
      onClick={handleItemClick}
      highlighted={occupiedCaptains}
    />
  );
};

DispatchCaptainsList.propTypes = {
  employees: PropTypes.array,
  handleUpdateModalState: PropTypes.func,
  selectedCaptainID: PropTypes.number,
};

export default DispatchCaptainsList;
